<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <box-dashboard-button
        v-for="(item,index) in botones"
        :key="'b-cont'+index"
        :icon="item.icon"
        :title="item.title"
        :color="item.color"
        :bgColor="item.bgColor"
        :fontColor="item.fontColor"
        :url="item.url"
        :style="item.style"
        :visibleMobile="item.visibleMobile"
      ></box-dashboard-button>
      <box-dashboard
        v-for="(item,index) in contadores"
        :key="'c-cont'+index"
        :icon="item.icon"
        :title="item.value"
        :sub-title="item.title"
        :color="item.color"
        :bgColor="item.bgColor"
        :fontColor="item.fontColor"
        :url="item.url"
        :style="item.style"
        :visibleMobile="item.visibleMobile"
      ></box-dashboard>
      <v-flex md6 sm-12 xs-12 class="pt-1">
        <ayuda urlFaqs="/FAQs"></ayuda>
      </v-flex>
      <v-flex md6 sm-12 v-if="!isXsOnly" class="pt-1">
        <ultimos-fichajes :flat="false"></ultimos-fichajes>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// @ is an alias to /src
import boxDashboard from "@/components/commons/boxDashboard";
import boxDashboardButton from "@/components/commons/boxDashboardButton";
import ayuda from "@/components/commons/ayuda";
import ultimosFichajes from "@/components/fichajes/ultimosFichajes";
import fichajeServices from "@/services/fichajeServices.js";
const moment = require("moment");
require("moment/locale/es");

export default {
  name: "home",
  components: {
    boxDashboard,
    boxDashboardButton,
    ayuda,
    ultimosFichajes
  },
  data() {
    return {
      loadingFichajes: true,
      botones: [
        {
          title: "Fichar",
          icon: "chat_bubble",
          color: "teal",
          bgColor: "teal",
          fontColor: "white--text",
          url: "/fichar",
          visibleMobile: true
        },
        {
          title: "Fichar con incidencia",
          icon: "chat",
          color: "lime darken-3",
          bgColor: "lime darken-3",
          fontColor: "white--text",
          url: "/fichar-incidencia",
          visibleMobile: true
        }
      ],
      contadores: [
        {
          title: "Último fichaje",
          value: "--",
          icon: "chat_bubble",
          color: "light-blue accent-4",
          bgColor: "light-blue lighten-5",
          fontColor: "light-blue--text text--accent-4",
          url: "/fichar",
          visibleMobile: true
        }
      ],
      fichajes: [
        {
          id: 458,
          tipo: "Fichaje",
          fecha: "25/01/2019 08:01",
          ubicacion: "Paseo de la castellana 166, Madrid"
        },
        {
          id: 420,
          tipo: "Fichaje",
          fecha: "24/01/2019 17:00",
          ubicacion: "Paseo de la castellana 166, Madrid"
        },
        {
          id: 416,
          tipo: "Fichaje",
          fecha: "24/01/2019 08:02",
          ubicacion: "Paseo de la castellana 166, Madrid"
        },
        {
          id: 400,
          tipo: "Fichaje con incidencia",
          fecha: "23/01/2019 15:02",
          motivo: "Médico",
          ubicacion: "Plaza galicia 3, Alcobendas, Madrid "
        },
        {
          id: 398,
          tipo: "Fichaje",
          fecha: "23/01/2019 07:58",
          ubicacion: "Paseo de la castellana 166, Madrid"
        },
        {
          id: 420,
          tipo: "Fichaje",
          fecha: "22/01/2019 17:02",
          ubicacion: "Paseo de la castellana 166, Madrid"
        }
      ],
      //formatDate: "DD/MM/YYYY HH:mm:ss",
    };
  },
  computed: {
    ...mapState("global", ["versionBack", "versionBFF", "versionFront"]),
    user: function() {
      return this.$store.state.authentication.user;
    },
    isXsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    }
  },
  created() {
    this.$store.commit("global/SET_MIGA", [{ text: "Inicio", href: "/" }]);

    if (this.user.userMustChangePassword) {
        this.$router.push("/cambiar-clave");
    }

    this.loadFichajes();
    this.loadUltimoFichaje();
  },
  methods: {
    loadFichajes() {
      var that = this;
      setTimeout(function() {
        that.loadingFichajes = false;
      }, 2000);
    },
    loadUltimoFichaje() {
      fichajeServices.getUltimosFichajes(this.user.employeeId).then(res => {
        if (!!res && res.length > 0){
            this.contadores[0].value = 
              moment
              .utc(res[0].markDateTime)
              .local()
              .format(this.getFormatoFechaToView);
        }
      });
    },
    goto: function(url) {
      this.$router.push(url);
    }
  }
};
</script>

